import { QuestionType } from '@follow/cdk'
import { QuestionnaireTemplateMutationPayload } from '../data/questionnaireTemplates/mapper/questionnaireTemplate.model'
import { QuestionTemplate, ScoreConfig } from '../model/Questionnaire'

export const buildNewQuestionnaire = (): QuestionnaireTemplateMutationPayload => {
  return {
    title: 'Nouveau questionnaire',
  }
}
export type QuestionContext = {
  questionnaireId?: number
  questionnaireTemplateId?: number
  documentInstanceId?: number
  documentTemplateId?: number
  displayOrder?: number
  parentAnswerId?: number
}

export function createDefaultQuestionTemplate(
  type: QuestionType,
  questionContext: QuestionContext,
): Partial<Omit<QuestionTemplate, 'id'>> {
  const {
    questionnaireTemplateId,
    questionnaireId,
    documentInstanceId,
    documentTemplateId,
    displayOrder,
    parentAnswerId,
  } = questionContext
  const questionnaireIds = typeof questionnaireId === 'number' ? [questionnaireId] : undefined
  const questionnaireTemplateIds =
    typeof questionnaireTemplateId === 'number' ? [questionnaireTemplateId] : undefined
  const documentIds = typeof documentInstanceId === 'number' ? [documentInstanceId] : undefined
  const documentTemplateIds =
    typeof documentTemplateId === 'number' ? [documentTemplateId] : undefined
  const baseQuestion = {
    title: '',
    type,
    questionnaireIds,
    questionnaireTemplateIds,
    documentIds,
    documentTemplateIds,
    displayOrder,
    parentAnswerId,
  }
  return type === QuestionType.Slider
    ? {
        ...baseQuestion,
        config: {
          leftValue: 0,
          rightValue: 10,
          stepValue: 1,
          inverted: false,
        },
      }
    : baseQuestion
}

export function toPercentage(min: number, max: number, scoreValue: number) {
  return (scoreValue - min) * 100 * (1 / (max - min))
}

export function getColorByScoreConfigAndValue(
  scoreConfig: ScoreConfig,
  scoreValue: number,
): 'green' | 'orange' | 'red' | undefined {
  const scaledValue = scoreConfig.percentage
    ? scoreValue
    : toPercentage(scoreConfig.min, scoreConfig.max, scoreValue)
  let color
  if (scaledValue <= 25) {
    color = scoreConfig.inverted ? 'green' : 'red'
  } else if (scaledValue <= 75) {
    color = 'orange'
  } else {
    color = scoreConfig.inverted ? 'red' : 'green'
  }
  return color
}
